define('data-entry/upload-view.controller',['angular'], function (angular) {
    'use strict';
    var DataUploadViewCtrl = function ($scope, userService, user, dataEntryService, $q, $log, $mdToast, $location, helper) {
        $scope.listView = function(){
            $location.path('/data-entry/list');
        };
        $scope.user = user.data.User;
        $scope.retrieveOrg = function (l) {
            return dataEntryService.retrieveOrg($scope.user.sessionID, l).then(function (data) {
                return data;
            }, function (e) {
                return [];
            });
        };
        var self = this;
        $scope.nomrn = false;
        $scope.formType = 'POLST';
        $scope.formTypes = ['POLST', 'AD', 'Hospital DNR', 'DPOA'];
        $scope.mrn = '';
        $scope.noCache = true;
        $scope.simulateQuery = false;
        $scope.isDisabled = false;
        $scope.selectedItem = undefined;
        $scope.searchTextChange = function (text) {
            $scope.selectedItem = undefined;
            $log.info('Text changed to ' + text);
        };
        $scope.validateDateSubmitted = function (dateStr) {
            $scope.invalidDateSubmitted = !helper.validateDate(dateStr);
        };
        $scope.invalidDateSubmitted = true;
        $scope.selectedItemChange = function (item) {
            $scope.selectedItem = item;
            $log.info('Item changed to ' + JSON.stringify(item));
        };
        $scope.uploadABBYYForm = function () {
            $scope.myPromise = dataEntryService.uploadABBYYForm($scope.pdfFile, $scope.csvFile, $scope.selectedItem.id, $scope.user.sessionID, $scope.afNotes, $scope.dateSubmitted, $scope.mrn, $scope.formType).then(function (response) {
                $mdToast.show({
                    hideDealy: 10000,
                    position: 'bottom right',
                    controller: 'ToastSuccessCtrl',
                    templateUrl: 'data-entry/upload-success.html'
                });
                $scope.searchText = '';
                $scope.selectedItem = undefined;
                $scope.pdfFile = undefined;
                $scope.csvFile = undefined;
                $scope.afNotes = '';
                $scope.formType = 'POLST';
                $scope.nomrn = false;
                $scope.mrn = '';
            });
        };
    };
    DataUploadViewCtrl.$inject = ['$scope', 'userService', 'user', 'dataEntryService', '$q', '$log', '$mdToast', '$location', 'helper'];
    return DataUploadViewCtrl;
});


/**
 Copyright 2016 Google Inc. All Rights Reserved.
 Use of this source code is governed by an MIT-style license that can be foundin the LICENSE file at http://material.angularjs.org/HEAD/license.
 **/;
